import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'ForwardCallPopover',

  components: {
    ShButton,
  },

  props: {
    callingAgentDetails: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      agentToForward: '',
      numberToForward: '',
      elementToForward: '',
      isForwarded: false,
      forwardedCallResponseStatus: 'success',
      statusDetails: {
        success: {
          icon: 'fa fa-check-circle',
          title: 'Ustawienie przekierowania przebiegło pomyślnie',
          description: 'Połączenie zostanie przekierowane w momencie zakończenia aktualnej rozmowy.',
        },
        error: {
          icon: 'fa fa-exclamation-circle',
          title: 'Przpraszamy, coś poszło nie tak',
          description: 'Połączenie nie zostało przekierowane poprawnie, prosimy o kontakt z opiekunem.',
        },
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes(['user/agent/forwardCall']);
    },
    agentsBelongsToClientList() {
      return this.$store.getters['client/agents/list'].records;
    },
    projectAlternativeMenuList() {
      return this.$store.getters['client/project/alternativeMenu/list'].records;
    },
  },

  async created() {
    await this.$store.dispatch('client/agents/getAgentsBelongsToClientList');
    await this.$store.dispatch('client/project/alternativeMenu/getList', this.callingAgentDetails.project_uuid);
  },

  methods: {
    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },
    async forwardCall() {
      const forwardNumber = this.agentToForward
        ? this.getAgentDetails(this.agentToForward)[0].nr_tel
        : this.numberToForward;

      const params = {
        forward_number: forwardNumber,
        forward_element: this.elementToForward,
        forwarded_agent: this.agentToForward ? this.getAgentDetails(this.agentToForward)[0].uuid : '',
        calling_agent: this.callingAgentDetails.uuid,
      };

      const response = await this.$store.dispatch('user/agent/forwardCall', params);
      this.isForwarded = true;
      this.forwardedCallResponseStatus = response.code === 200 ? 'success' : 'error';
    },
    clearNumber() {
      this.numberToForward = '';
    },
    clearAgent() {
      this.agentToForward = '';
    },
    clearElement() {
      this.elementToForward = '';
    },
    getAgentDetails(agentUuid) {
      return this.agentsBelongsToClientList.filter(agent => agent.uuid === agentUuid);
    },
    clearForm() {
      this.clearNumber();
      this.clearAgent();
      this.clearElement();
      this.isForwarded = false;
    },
  },
};
